<template>
<div class="el-main"
  ref="mainViewer">
  <div class="card" v-show="currentCardId == 'info'">
    <div class="overflow-scroll-y">
        <div class="card-header">
            <h2>ヤギの宅配便をつかう</h2>
        </div>
    </div>


    <p style="font-size: 1rem; text-align: center;">あなたが作った履歴書を<br>
      <span style="color: #e3165c; font-weight: bold;">応募先企業に送ります</span>
    </p>

    <div style="text-align: center; margin-bottom: 15px;">
        <button type="button" @click="$eventHub.$emit('go_next_card')" class="el-button el-button--primary"><!----><!----><span>
            ヤギの宅配便をつかう <i class="el-icon-d-arrow-right"></i></span></button>
    </div>

    <div style="width: 500px; max-width: 100%; margin: 20px auto;">
      <p style="text-align: center; margin-bottom: 5px;">かんたん3ステップで履歴書が応募先企業に送れる！</p>
      <ul style="display: flex; justify-content: space-between; flex-wrap: wrap; margin-bottom: 15px;">
        <li style="border: 2px solid #99B8B3;border-radius: 5px;padding: 10px 0 10px 10px;margin-bottom: 10px;width: 100%;">
          <span style="font-weight: bold; color: #99B8B3;">STEP１：</span>履歴書をつくる
        </li>
        <li style="border: 2px solid #99B8B3;border-radius: 5px;padding: 10px 0 10px 10px;margin-bottom: 10px;width: 100%;">
          <span style="font-weight: bold; color: #99B8B3;">STEP2：</span>送り先入力
        </li>
        <li style="border: 2px solid #99B8B3; border-radius: 5px; padding: 10px 0 10px 10px; width: 100%;">
          <span style="font-weight: bold; color: #99B8B3;">STEP3：</span>最短1時間で郵送！
        </li>
      </ul>
    </div>

    <div style="margin-bottom: 15px;">
        <img src="/static/renew2_img/quickmail_merit04.png">
    </div>

    <div style="margin-bottom: 15px;">
        <p>注意事項</p>
        <ul style="list-style-type: disc; padding-left: 20px; font-size: .75rem;">
            <li>ヤギの宅配便サービスのご利用にはヤギッシュへのアカウント登録が必要です</li>
            <li>履歴書が送付された際はメールにて通知されますが、実際に投函した写真をお送りすることもできます</li>
        </ul>
    </div>

  </div>
  <div class="card" v-show="currentCardId == 'info20240531'">
    <div class="overflow-scroll-y">
        <div class="card-header">
            <h2>ヤギの宅配便をつかう</h2>
            <p>ヤギの宅配便は、あなたに代わって、弊社が履歴書を紙で印刷し、封筒に入れ、企業への提出まで代行するサービスです。</p>
        </div>
    </div>

    <div style="text-align: center; margin-bottom: 15px;">
        <button type="button" @click="$eventHub.$emit('go_next_card')" class="el-button el-button--primary"><!----><!----><span>
            ヤギの宅配便をつかう <i class="el-icon-d-arrow-right"></i></span></button>
    </div>

    <div style="display: flex; justify-content: space-between; flex-wrap: wrap; margin-bottom: 15px;">
        <img src="/static/renew2_img/quickmail_merit01.png" style="width: calc(50% - 5px);margin-bottom: 10px;">
        <img src="/static/renew2_img/quickmail_merit02.png" style="width: calc(50% - 5px);margin-bottom: 10px;">
        <img src="/static/renew2_img/quickmail_merit03.png" style="width: calc(50% - 5px);">
    </div>

    <div style="margin-bottom: 15px;">
        <img src="/static/renew2_img/quickmail_merit04.png">
    </div>

    <div style="margin-bottom: 15px;">
        <p>注意事項</p>
        <ul style="list-style-type: disc; padding-left: 20px; font-size: .75rem;">
            <li>ヤギの宅配便サービスのご利用にはヤギッシュへのアカウント登録が必要です</li>
            <li>履歴書が送付された際はメールにて通知されますが、実際に投函した写真をお送りすることもできます</li>
        </ul>
    </div>

  </div>
  <div class="card" v-show="currentCardId == 'basic'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>送付先情報入力</h2>
        <p>建物名や部屋番号は略さず入力しましょう。</p>
      </div>
      <div class="card-content">
        <div class="edit-form">
          <div class="edit-form-item">
            <div class="item-name">
              郵便番号
              <small v-if="$deviceLib.isOnline">(ハイフン不要・住所が自動入力されます)</small>
              <small v-else>(※オフラインのため住所の自動入力がご利用いただけません)</small>
            </div>
            <div class="item-body">
              <el-input class="input-7-digit"
                placeholder="1001000"
                title="郵便番号"
                type="tel"
                ref="postNumber"
                v-model.lazy="formatData.addressData_postNumber"></el-input>&nbsp;
                <el-button id="send-adtop-pdf" type="success" style="background-color:#0F9934;border-color:#0F9934;padding: 10px;"
                @click="selectedPostnumber();">自動入力</el-button>
            </div>
            <div class="item-name">都道府県・市区町村・番地</div>
            <div class="item-body">
              <el-input 
                autosize
                placeholder=""
                title="都道府県・市区町村"
                ref="address1"
                v-model="formatData.addressData_address1"
                v-on:blur="formatData.addressData_address1 = $formLib.zenToHanNumber($event.target.value)"></el-input>
            </div>
            <div class="item-name">マンション・建物名等</div>
            <div class="item-body">
              <el-input 
                autosize
                placeholder=""
                title="マンション・建物名等"
                ref="address2"
                v-model="formatData.addressData_address2"
                v-on:blur="formatData.addressData_address2 = $formLib.zenToHanNumber($event.target.value)"></el-input>
            </div>
          </div>
          <div class="edit-form-item">
            <div class="item-name">送付先の会社名</div>
            <div class="item-body">
              <el-input 
                autosize
                placeholder="会社名"
                title="会社名"
                ref="companyName"
                v-model="formatData.addressData_companyName"></el-input>
            </div>
          </div>
          <div class="edit-form-item">
            <div class="item-name">送付先の担当者名 ※様の入力は不要です。</div>
            <div class="item-body">
              <el-input 
                autosize
                placeholder="ご担当者"
                title="担当者名"
                ref="staffName"
                v-model.lazy="formatData.addressData_staffName"
                style="min-height: 36px;height: 36px;width: 80%;"
                v-model="formatData.addressData_staffName"></el-input>
                <span style="display: inline;padding: 5px;font-size: 120%;">様</span>
            </div>
          </div>
        </div>

        <div class="edit-form">
          <div class="edit-form-item">
            <p class="card-header2" style="border-bottom: none; border-top: 1px solid #f8f8f8; padding: 30px 5px 0 0; margin: 0; color: #004d40; font-weight: bold;">差出人情報</p>
            <p class="card-header2" style="border: none; padding: 0; font-size: .75rem;">履歴書に入力した住所と異なる場合は入力しましょう。</p>
            <div class="item-name">
              差出人の郵便番号
              <small v-if="$deviceLib.isOnline">(ハイフン不要)</small>
              <small v-else>(※オフラインのため住所の自動入力がご利用いただけません)</small>
            </div>
            <div class="item-body">
              <el-input class="input-7-digit"
                placeholder="1001000"
                title="郵便番号"
                type="tel"
                ref="from_postNumber"
                v-model.lazy="formatData.from_post"
                ></el-input>
            </div>
            <div class="item-name">差出人の都道府県・市区町村・番地</div>
            <div class="item-body">
              <el-input 
                autosize
                placeholder=""
                title="都道府県・市区町村"
                ref="from_address1"
                v-model="formatData.from_address1"
                v-on:blur="formatData.from_address1 = $formLib.zenToHanNumber($event.target.value)"></el-input>
            </div>
            <div class="item-name">マンション・建物名等</div>
            <div class="item-body">
              <el-input 
                autosize
                placeholder=""
                title="マンション・建物名等"
                ref="from_address2"
                v-model="formatData.from_address2"
                v-on:blur="formatData.from_address2 = $formLib.zenToHanNumber($event.target.value)"></el-input>
            </div>
          </div>
          <div class="edit-form-item">
            <div class="item-name">差出人名</div>
            <div class="item-body">
              <el-input 
                autosize
                placeholder=""
                title="差出人名"
                ref="from_userName"
                v-model="formatData.from_name"></el-input>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="card" v-show="currentCardId == 'letter'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>送付状確認</h2>

        <p class="edit_btn">
          ＼一度作成した保存データがヤギの宅配便で使えるよ！／<br>
          <a href="/format/letter/edit/letterprofile" class="edit_btn_link"><i class="el-icon-edit"></i>送付状を編集・新規作成する</a>
        </p>

        <p>送付状の内容に間違いがないかご確認ください。</p>
        <span style="color:red;" v-if="formatData.addressData_isLetter == '1'">※プレビューに赤い色が見えた場合はプリントに問題があるので、赤い色がなくなるよう内容を編集してください。</span>
        <span style="color:red;" v-else-if="formatData.addressData_isLetter == '0'">※送付状が作成されていないので、送付される書類に添付されません。</span>
        
        <div class="edit-form-item" v-if="false">
          <div class="item-body">
            <el-checkbox v-model="formatData.addressData_isLetter">送付状を添付する</el-checkbox>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="card" v-show="currentCardId == 'rirekisho'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>履歴書確認</h2>
        <p class="edit_btn">
          ＼一度作成した保存データがヤギの宅配便で使えるよ！／<br>
          <a :href="rirekishoUrl" class="edit_btn_link"><i class="el-icon-edit"></i>履歴書を編集・新規作成する</a>
        </p>
        <p>履歴書の内容に間違いがないかご確認ください。</p>
        <span style="color:red;">※プレビューに赤い色が見えた場合はプリントに問題があるので、赤い色がなくなるよう内容を編集してください。</span>
        
      </div>
      <div class="edit-form-item" style="text-align:center;">
        <h3>履歴書フォーマット選択 </h3>
        <div class="item-body">
          <el-select v-model="formatData.selFormat"
                autosize
            placeholder="選択してください">
            <el-option v-for="item in formatListOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"></el-option>
          </el-select>&nbsp;
          <el-button id="send-adtop-pdf" type="success" 
          style="background-color:#0F9934;border-color:#0F9934;;padding: 10px;"
          @click="selectFormat();">選択する</el-button>
        </div>
      </div>
    </div>
  </div>
  <div class="card" v-show="currentCardId == 'keirekisho'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>職務経歴書確認</h2>
        <p class="edit_btn">
          ＼一度作成した保存データがヤギの宅配便で使えるよ！／<br>
          <a href="/format/shokumukeirekisho/edit/profile" class="edit_btn_link"><i class="el-icon-edit"></i>職務経歴書を編集・新規作成する</a>
        </p>
        <p>職務経歴書の内容に間違いがないかご確認ください。</p>
        
        <div class="edit-form-item">
          <div class="item-body">
            <el-checkbox v-model="formatData.addressData_isKeirekisho">職務経歴書を添付する</el-checkbox>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="card" v-show="currentCardId == 'payment'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>支払い</h2>
        <p v-if="false">ヤギの宅配便は、 <a id="amazon-quick-mail-btn" href="https://amzn.to/3weli5Y" style="color:red;" target="_blank">Amazonでのご購入</a>か、、PayPay払いとクレジットカード決済が可能です。<br>
        ご利用いただけますカードは、Visa・MasterCard・American Express・JCB・Diners Club・Discoverです。<br>
        ヤギの宅配便は投函までに1-2日ほどいただきますので、ご了承ください。なお送付先に届くまでの期間については配送地域や交通状況により異なります。</p>
        <p >PayPayまたはクレジットカードで支払いが可能です。<br>
        支払いが完了次第、順次応募先へ書類を提出いたします。（投函に1-2日いただく場合もあります。）
        </p>
        <p class="terms_link"><a href="/quickmailterms" target="_blank">利用規約はこちら</a></p>
      </div>
    </div>
    <div class="item-body" v-if="paymentMethodTab=='card'" style="margin-bottom: 20px;">
      <h3>購入金額</h3>
      <span style="font-size: 120%;color:red;">1,100円（税込）</span>
    </div>
    <div class="item-body" v-if="paymentMethodTab=='paypay'" style="margin-bottom: 20px;">
      <h3>購入金額</h3>
      <span style="font-size: 120%;color:red;">1,100円（税込）</span>
    </div>
    <div class="item-body" v-if="paymentMethodTab=='amazon'" style="margin-bottom: 20px;">
      <h3>購入金額</h3>
      <span style="font-size: 120%;color:red;">1,098円（税込）</span>
    </div>
    
    <el-collapse accordion v-model="paymentMethodTab" @change="changePaymentMethod">
      <el-collapse-item name="amazon" v-if="false">
        <template slot="title" >
          <div class="yagitaku">
            <el-radio v-model="paymentMethodTab" label="amazon">{{ '' }}</el-radio> <span class="yagitaku_recommend" v-if="false">オススメ</span>Amazonで購入
          </div>
        </template>
        <div class="el-collapse-item__content" style="padding-bottom: 20px;">
          <p style="text-align: center; font-weight: bold;" v-if="false">＼3/8までAmazon限定<span style="color: red;">20％OFF！</span>／　</p>
          <a id="amazon-quick-mail-btn" href="https://amzn.to/3weli5Y" target="_blank" 
          style="width: 100%;display: flex;justify-content: center;align-items: center;background: #fff;border-radius: 50px;border: 2px solid #E3165C;padding: 5px 0 0 0;margin: 5px 0;font-weight: bold;"><img 
          src="/static/renew2_img/amazon-logo.png" style="width: 100px;">で詳細を見る</a>
          <a v-if="false" id="amazon-quick-mail-btn" href="https://amzn.to/3weli5Y" target="_blank" style="width:100%"><img src="/static/renew2_img/amazon-logo.png" style="width:100px;"></a>
          <p style="font-size: 90%;color: red;margin-top: 20px;">※Amazonで購入後、再度ヤギの宅配便の決済ページにて「コードで支払い」を選択し、決済を完了してください</p>
          <p v-if="false">＼1/31までAmazon購入に限り<span style="color:red;">20％OFF！</span>／　＼<span style="color:red;">880円</span>（税込）／<br>
            Amazonの購入は　<a id="amazon-quick-mail-btn" style="color:blue;" href="https://amzn.to/3weli5Y" target="_blank">https://amzn.to/3weli5Y</a>　から行えます。
          </p>
        </div>
      </el-collapse-item>
      <el-collapse-item name="card">
        <template slot="title" >
          <div class="yagitaku">
            <el-radio v-model="paymentMethodTab" label="card" >{{ '' }}</el-radio> カードで支払い
          </div>
        </template>
        <div class="el-collapse-item__content" style="padding-bottom: 20px;padding-right: 0;padding-left: 0;">
          <div class="item-name">
            <h3>カード情報</h3>
          </div>
          <stripe-element-card
            ref="stripeCardElememt"
            :pk="publishableKey"
            :hidePostalCode="true"
            @token="tokenCreated" />
          <span style="font-size: 90%;color:red;">※お客様のカード情報は保存されません。</span>
        </div>
      </el-collapse-item>
      <el-collapse-item name="paypay">
        <template slot="title" >
          <div class="yagitaku">
            <el-radio v-model="paymentMethodTab" label="paypay">{{ '' }}</el-radio> PayPayで支払い
          </div>
        </template>
        <div class="el-collapse-item__content" style="padding-bottom: 20px;">
          <a id="paypay-quick-mail-btn" @click="$eventHub.$emit('get_paypay_code')" ><img 
          src="/static/renew2_img/paypay_payment_lg.png" style="width: 300px;"></a>
          <br>
          <span style="font-size: 90%;color: red;display: inline-block;text-align: left;padding-top: 10px;">※支払いが完了し、しばらくすると自動でヤギの宅配便ページに戻ります<br>戻る前にページを閉じると購入が失敗する可能性があります</span>
        </div>
      </el-collapse-item>
      <el-collapse-item name="code">
        <template slot="title" >
          <div class="yagitaku">
            <el-radio v-model="paymentMethodTab" label="code">{{ '' }}</el-radio> コードで支払い
          </div>
        </template>
        <div class="el-collapse-item__content" style="padding-bottom: 20px;">
          <div class="item-name">
            <h3>コード情報</h3>
          </div>
          <el-input 
            autosize
            placeholder=""
            title="コードを入力してください"
            ref="ec_code"
            v-model="formatData.ecCode"></el-input>
        </div>
      </el-collapse-item>
    </el-collapse>

    <div class="card-content">
      <div class="edit-form">
        <div class="edit-form-item">
          <div class="item-name">
            <h3 class="h3" style="margin: 30px 0 10px;">送付先情報<a href="#" @click="$eventHub.$emit('goto_basic')" class="fix"><i class="el-icon-edit"></i>修正する</a></h3>
          </div>
          <div class="item-body" style="margin-left:10px;">
            〒{{formatData.addressData_postNumber}}<br>
            {{formatData.addressData_address1}}<br>
            {{formatData.addressData_address2}}<br>
            {{formatData.addressData_companyName}}<br>
            {{addressDataStaffName}} 様
            <span v-if="isValidStaffname" style="color:red;">※不要な「様」「さま」の入力がないか確認してください。</span>
            <span v-if="isNoneStaffname" style="color:red;">※担当者名を入力してなかったので「ご担当者」と自動入力されました。</span>
          </div>
          <div class="item-name">
            <h3 class="h3" style="margin: 30px 0 10px;">差出人情報<a href="#" @click="$eventHub.$emit('goto_basic')" class="fix"><i class="el-icon-edit"></i>修正する</a></h3>
          </div>
          <div class="item-body" style="margin-left:10px;">
            〒{{formatData.from_post}}<br>
            {{formatData.from_address1}}<br>
            {{formatData.from_address2}}<br>
            {{formatData.from_name}}
          </div>
          <div class="item-name">
            <h3 class="h3" style="margin: 30px 0 10px;">送付内容</h3>
            <p>※送付内容を変更する場合はそれぞれのページでご確認ください。</p>
          </div>
          <div class="item-body" style="margin-left:10px;">
            <p v-if="formatData.addressData_isLetter == '1'"><i class="el-icon-document"></i> 送付状</p>
            <p><i class="el-icon-document"></i> 履歴書（{{formatData.rirekishoFormatName}}）</p>
            <p v-if="formatData.addressData_isKeirekisho"><i class="el-icon-document"></i> 職務経歴書</p>
            <span style="color:red;" v-if="formatData.addressData_isLetter == '0'">※送付状が作成されていないので、送付される書類に添付されません。</span>
          </div>
        </div>
      </div>
      <p class="terms_link"><a href="/quickmailterms" target="_blank">利用規約はこちら</a></p>
    </div>
  </div>
  <div class="card" v-show="currentCardId == 'complete'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>購入完了</h2>
        <div class="edit-form-item" style="text-align:center;padding: 10px 0 30px; font-weight: bold;">
          購入詳細はメールにてお送りいたしましたので、ご確認お願いいたします。
        </div>
        <p>ヤギの宅配便をご購入いただき、ありがとうございました。
        <br>ヤギの宅配便は投函までに1-2日ほどいただきますので、ご了承ください。なお送付先に届くまでの期間については配送地域や交通状況により異なります。</p>
      </div>


      <h3 class="next_bnr">次は何する？</h3>
      <div class="bnr_container">
          <div class="bnr_itemWrapper">
            <div class="bnr_item">
              <img src="/static/renew_img/mailbuy.png" alt="ヤギの宅配便">
              <div class="bnr_txt">
                <a href="#" @click="$eventHub.$emit('goto_basic')">
                  <p>違う会社にも送るの任せろメェ〜</p>
                  <h3>ヤギの宅配便<span>をつかう</span></h3>
                </a>            
              </div>
            </div>
          </div>
          <div class="bnr_itemWrapper">
            <div class="bnr_item">
              <img src="/static/renew_img/print.png" alt="コンビニプリント">
              <div class="bnr_txt">
                <a  :href="rirekishoOutputUrl">
                  <p>面接に履歴書が必要？印刷だメェ〜</p>
                  <h3>コンビニプリント<span>をつかう</span></h3>
                </a>
              </div>
            </div>
          </div>
      </div>


    </div>
  </div>

  <div class="preview-viewer tab-content"
      :style="previewLabelViewerCss"
      v-show="currentCardId == 'basic'">
    <component v-bind:is="label_preview"
      ref="previewLabelFormat"
      :id-prefix="''"
      :format-data="formatData"
      :format-id="formatId"
      :basic-data="basicData"
      :preview-scale="previewScale/1.3"
      :current-card-id="currentCardId"></component>
  </div>
  <div class="preview-viewer tab-content"
      :style="previewLetterViewerCss"
      v-show="currentCardId == 'letter'">
    <component v-bind:is="letter_preview"
      ref="previewLetterFormat"
      :id-prefix="''"
      :format-data="formatLetterData"
      :format-id="formatId"
      :basic-data="basicData"
      :preview-scale="previewScale"
      :current-card-id="currentCardId"></component>
  </div>
  <div class="preview-viewer tab-content"
      :style="previewRirekishoViewerCss"
      v-show="currentCardId == 'rirekisho'">
    <component v-bind:is="rirekisho_preview"
      ref="previewRirekishoFormat"
      :id-prefix="''"
      :format-data="formatRirekishoData"
      :format-id="formatId"
      :basic-data="basicData"
      :preview-scale="previewScale"
      :current-card-id="currentCardId"></component>
  </div>
  <div class="preview-viewer tab-content"
      :style="previewKeirekishoViewerCss"
      v-show="currentCardId == 'keirekisho'">
    <component v-bind:is="keirekisho_preview"
      ref="previewKeirekishoFormat"
      :id-prefix="''"
      :format-data="formatKeirekishoData"
      :format-id="formatId"
      :basic-data="basicData"
      :preview-scale="previewScale"
      :current-card-id="currentCardId"></component>
  </div>
  <modal name="open_paypay_modal"
          :adaptive="true"
          :scrollable="true"
          height="auto">
    <div class="v--modal-close-top">
      <el-button @click="$modal.hide('open_paypay_modal');"
                  icon="el-icon-close"
                  type="text"></el-button>
    </div>
    <div class="title" style="text-align: center;color: rgb(231, 54, 0);">決済しただけでは注文は完了しません</div>
    <br>
    <span>注文を完了するにはPayPay決済画面のご利用中のサービスに戻るボタンを押下してください。</span>
    <div style="width: 100%"><img src="/static/renew2_img/paypay_alert_image_20240214.png" style="width: 100%"></div>
    <div class="text-center">
      <el-button type="primary" style="width: 100%;height:70px;" @click="openPayPaySite">注意事項を理解し、決済サービスを開く</el-button>
    </div>
  </modal>
</div>
</template>
<style lang="scss" scoped>
.terms_link{
  text-align: right;
  margin: 10px 0;
}

.terms_link_deco{
  color: #E3165C;
  text-decoration:underline;
}
.addition {
  font-size: .75rem;
  margin: .5rem 0;
}
.card-header h1{
  padding-bottom: 1.5rem;
}
.card-header h2{
  padding-bottom: 1.5rem;
}
.card-header2{
  border-bottom: 1px solid #f8f8f8;
  padding-bottom: 15px;
  margin-bottom: 20px;
}
.h3{
  padding-left: 10px;
  border-left: 4px solid #0F9934;
}
.fix{
  margin-left: 20px;
}
.fix1:before{
  content: "\e5df";
  color: #004d40;
}
* {
	list-style: none;
	box-sizing: border-box;
	margin: 0;
	padding: 0;
}

img {
	width: 100%;
	vertical-align: bottom;
}

.next_bnr{
  font-size: 1rem;
  color: #004d40;
  text-align: center;
  padding: 1.2rem;
}

.bnr_container {
	display: flex;
	flex-wrap: wrap;
	margin: calc(-30px / 2);
	padding: 0 30px 30px;
}

.bnr_itemWrapper {
	width: calc(100% / 2 - 30px);
	margin: calc(30px / 2);
}

.bnr_item {
  text-align: center;
}

.bnr_item img{
  border-radius: 10px 10px 0 0 ;
}

.bnr_txt{
  padding: 15px;
  background: #EFF8F8;
  border-radius: 0 0 10px 10px;
}

.bnr_txt p{
  font-size: 0.8rem;
}

.bnr_txt h3{
  color: #E3165C;
  font-size: 1.1rem;
  font-weight: bold;
}

.bnr_txt span{
  font-size: 0.8rem;
}

/* タブレット　2カラム */
@media screen and (max-width: 1024px) {
	.bnr_itemWrapper {
		width: calc(100% / 2 - 30px);
	}
}
/* スマホ 1カラム*/
@media screen and (max-width: 599px) {
	.bnr_itemWrapper {
		width: calc(100% / 1 - 30px);
	}
}

.edit_btn{
  text-align: center;
  margin: 5px auto 15px;
}

.edit_btn a{
  color: #fff;
}

.edit_btn_link{
  display: inline-block;
  background: #004D40;
  padding: 8px 30px;
  border-radius: 20px;
  color: #fff;
  font-weight: bold;
  margin-left: 0;
}

.yagitaku_recommend{
  color: #fff;
  background: #E3165C;
  padding: 5px 10px;
  margin-right: 5px;
  border-radius: 50px;
}
</style>
<script>
import {
  TabPane,
  Tabs
} from 'element-ui'
import HistoryItem from './RirekishoParts/HistoryItem'
import AutoEducationalBackgrounds from './RirekishoParts/AutoEducationalBackgrounds'
import AutoJobHistories from './RirekishoParts/AutoJobHistories'
import LocalDataMixin from '@/mixins/local-data-mixin'
import LoginForms from '@/components/LoginForms'
import RirekishoPreview from '@/components/formats/RirekishoPreview'
import NewRirekishoPreview from '@/components/formats/NewRirekishoPreview'
import ShokurekishoPreview from '@/components/formats/ShokurekishoPreview'
import LetterPreview from '@/components/formats/LetterPreview'
import LabelPreview from '@/components/formats/LabelPreview'

import { StripeElementCard } from '@vue-stripe/vue-stripe'

// 書式1枚の高さ
const DOC_PAPER_WIDTH_PX = 794

const uuidv4 = function () {
  const cryptoObj = window.crypto || window.msCrypto
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (c ^ cryptoObj.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  )
}
const HistoryData = function (year, month, description) {
  this.year = Number(year) || ''
  this.month = Number(month) || ''
  this.description = description || ''
  this.uuid = uuidv4()
}
export default {
  name: 'QuickmailBuy',
  props: {
    previewFormat: {
      type: Object,
      require: true
    },
    currentCardId: {
      type: String
    },
    exampleSentences: {
      type: Object
    }
  },
  mixins: [LocalDataMixin],
  components: {
    'history-item': HistoryItem,
    'auto-educational-backgrounds': AutoEducationalBackgrounds,
    'auto-job-histories': AutoJobHistories,
    'login-forms': LoginForms,
    'el-tabs': Tabs,
    'el-tab-pane': TabPane,
    StripeElementCard
  },
  data: function () {
    return {
      publishableKey : process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
		  basicData: {},
      addressData: {},
      saveName: 'quickmail',
      formatId: 'rirekisho_job_change',
      paypay_url: '',
      rirekisho_preview: RirekishoPreview,
      keirekisho_preview: ShokurekishoPreview,
      letter_preview: LetterPreview,
      label_preview: LabelPreview,
      formatRirekishoData: {},
      formatKeirekishoData: {},
      formatLetterData: {},
      addressDataStaffName: "",
      rirekishoUrl:'/format/rirekisho_job_change/edit/profile',
      rirekishoOutputUrl:'/format/rirekisho_job_change/edit/output',
      activeHistoryItem: '',
      rirekishoFormatName:'転職用の履歴書（JIS規格）',
      educationalResetDialogVisible: false,
      jobResetDialogVisible: false,
      descriptionMaxLength: 80,
      mailPdfEnabled: true,
      downloadPdfEnabled: true,
      isSendYagiPostEnabled: true,
      letterInnerHtml: '',
      rirekishoInnerHtml: '',
      keirekishoInnerHtml: '',
      ecCode:'',
      paymentMethodTab: 'paypay',
      paymentMethod: 'paypay',
      tempMethod: 'paypay',
      previewHtml: '',
      previewDialogVisible: true,
      previewScale: 1,
      previewRirekishoViewerCss: {},
      previewKeirekishoViewerCss: {},
      previewLetterViewerCss: {},
      previewLabelViewerCss: {},
      previewTabActive: 'previewFormat',
      isNew: false,
      textareaMinRows: 3,
      isValidStaffname: false,
      isNoneStaffname: false,
      downloadActiveCollapses: ['postcard'],
      formatListOptions: [],
      gradeYearOptions: [
        {
          value: '23',
          label: '23年卒'
        },
        {
          value: '24',
          label: '24年卒'
        },
        {
          value: '99',
          label: 'その他'
        }
      ],
      fontOptions: [
        {
          value: "font-family: 'Noto Sans JP', sans-serif;",
          label: 'Noto Sans JP'
        },
        {
          value: "font-family: 'Noto Serif JP', serif;",
          label: 'Noto Serif JP'
        },
        {
          value: "font-family: 'Zen Maru Gothic', sans-serif;",
          label: 'yagishゴシック'
        },
        {
          value: "font-family: 'BIZ UDPMincho', serif;",
          label: 'yagish明朝'
        },
        {
          value: "font-family: 'DotGothic16', sans-serif;",
          label: 'ドットゴシック16'
        },
        {
          value: "font-family: 'Kiwi Maru', serif;",
          label: 'Kiwi Maru'
        },
        {
          value: "font-family: 'Klee One', cursive;",
          label: 'Klee One'
        },
        {
          value: "font-family: 'Kosugi', sans-serif;",
          label: 'Kosugi'
        },
        {
          value: "font-family: 'Zen Kurenaido', sans-serif;",
          label: 'Zen Kurenaido'
        }
      ],
      fontNames: [
        {
          value: "font-family: 'Noto Sans JP', sans-serif;",
          label: 'Noto Sans JP'
        },
        {
          value: "font-family: 'Noto Serif JP', serif;",
          label: 'Noto Serif JP'
        },
        {
          value: "font-family: 'Zen Maru Gothic', sans-serif;",
          label: 'yagishゴシック'
        },
        {
          value: "font-family: 'BIZ UDPMincho', serif;",
          label: 'yagish明朝'
        },
        {
          value: "font-family: 'DotGothic16', sans-serif;",
          label: 'ドットゴシック16'
        },
        {
          value: "font-family: 'Kiwi Maru', serif;",
          label: 'Kiwi Maru'
        },
        {
          value: "font-family: 'Klee One', cursive;",
          label: 'Klee One'
        },
        {
          value: "font-family: 'Kosugi', sans-serif;",
          label: 'Kosugi'
        },
        {
          value: "font-family: 'Zen Kurenaido', sans-serif;",
          label: 'Zen Kurenaido'
        }
      ],
    }
  },
  computed: {
    getMode: function () {
      return process.env.VUE_APP_MODE
    }
  },
  methods: {
    tokenCreated (token) {
      const app = this
      app.$eventHub.$emit('loading_on')
      this.token = ""
      if (token) {
        this.token = token.id
      }
      if (this.formatData.addressData_isKeirekisho) {
        if (app.formatLetterData.resumeSummary) {
          if (app.formatLetterData.resumeSummary.indexOf('職務経歴書') < 0 && 
            app.formatLetterData.resumeSummary.indexOf('経歴書') < 0) {
            app.$message({
              message: '送付状の同封書類に職務経歴書の記載がありません。ご確認ください。',
              type: 'error'
            })
            app.$eventHub.$emit('payment_result', 'error')
            return
          } else {
            console.error('no problem')
          }
        } else {
          app.$message({
            message: '送付状の同封書類に職務経歴書の記載がありません。ご確認ください。',
            type: 'error'
          })
          app.$eventHub.$emit('payment_result', 'error')
          return
        }
      } else {
        if (app.formatLetterData.resumeSummary) {
          if (app.formatLetterData.resumeSummary.indexOf('職務経歴書') < 0 && 
            app.formatLetterData.resumeSummary.indexOf('経歴書') < 0) {
            console.error('no problem')
          } else {
            app.$message({
              message: '送付状の同封書類に職務経歴書の記載があります。ご確認ください。',
              type: 'error'
            })
            app.$eventHub.$emit('payment_result', 'error')
            return
          }
        }
      }
      if (this.letterInnerHtml == '') {
        this.setLetterInnerHtml()
      }
      if (!this.$globalVar.qmailRirekishoHtml) {
        this.$message({
          message: '問題が発生しました。画面を更新してから再度購入ボタンを押してください。',
          type: 'error'
        })
        return
      }
      const formData = new FormData()
      formData.append('stripe_token', this.token)
      formData.append('quickmail_post', this.formatData.addressData_postNumber)
      formData.append('quickmail_address1', this.formatData.addressData_address1)
      formData.append('quickmail_address2', this.getInputValue(this.formatData.addressData_address2))
      formData.append('quickmail_companyname', this.formatData.addressData_companyName)
      formData.append('quickmail_staffname', this.addressDataStaffName)
      formData.append('rirekisho_html', this.$globalVar.qmailRirekishoHtml)
      formData.append('keirekisho_html', this.keirekishoInnerHtml)
      formData.append('letter_html', this.letterInnerHtml)
      formData.append('letter_flag', this.formatData.addressData_isLetter)
      formData.append('keirekisho_flag', this.formatData.addressData_isKeirekisho ? '1':'0')
      formData.append('format_id', this.formatData.selFormat)
      formData.append('font_name', this.formatData.selFontStyle4DB)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('from_post', this.formatData.from_post)
      formData.append('from_address1', this.formatData.from_address1)
      formData.append('from_address2', this.getInputValue(this.formatData.from_address2))
      formData.append('from_name', this.formatData.from_name)
      formData.append('app_flag', this.$site.appFlag)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '3')
      formData.append('site_flag', 'r')
      formData.append('payment_code', this.formatData.ecCode)
      formData.append('payment_method', this.paymentMethodTab)

      const _tempHtml = this.$refs.previewLetterFormat.$el.innerHTML 
      + this.$refs.previewRirekishoFormat.$el.innerHTML 
      + this.$refs.previewKeirekishoFormat.$el.innerHTML
      formData.append('all_html', _tempHtml)

      this.$axios
        .post(this.$varuna.endPoints.paymentQuickmail, formData, {timeout: 60000})
        .then(function (response) {
          if (response.data['status'] == 'success') {
            app.$message({
              message: '購入完了しました',
              type: 'success'
            })
            app.$eventHub.$emit('payment_result', 'success')
          } else if (response.data['status'] == 'code_error') {
            app.$message({
              message: '利用済みコードか、入力したコードに問題があり、決済失敗しました。',
              type: 'error'
            })
            app.$eventHub.$emit('payment_result', 'error')
          } else {
            app.$message({
              message: '決済失敗しました',
              type: 'error'
            })
            app.$eventHub.$emit('payment_result', 'error')
          }
        })
        .catch(function (error) {
          app.$message({
            message: '決済失敗しました',
            type: 'error'
          })
          app.$eventHub.$emit('payment_result', 'error')
        }).finally(function () {
        })
    },
    openPayPaySite: function() {
      const app = this
      app.$eventHub.$emit('email_loading_on')
      app.$eventHub.$emit('complate_paypay', app.merchant_payment_id)
      location.href=this.paypay_url
    },
    savePayPayTempData (merchant_payment_id, url) {
      const app = this
      
      
      if (this.formatData.addressData_isKeirekisho) {
        if (app.formatLetterData.resumeSummary) {
          if (app.formatLetterData.resumeSummary.indexOf('職務経歴書') < 0 && 
            app.formatLetterData.resumeSummary.indexOf('経歴書') < 0) {
            app.$message({
              message: '送付状の同封書類に職務経歴書の記載がありません。ご確認ください。',
              type: 'error'
            })
            app.$eventHub.$emit('payment_result', 'error')
            return
          } else {
            console.error('no problem')
          }
        } else {
          app.$message({
            message: '送付状の同封書類に職務経歴書の記載がありません。ご確認ください。',
            type: 'error'
          })
          app.$eventHub.$emit('payment_result', 'error')
          return
        }
      } else {
        if (app.formatLetterData.resumeSummary) {
          if (app.formatLetterData.resumeSummary.indexOf('職務経歴書') < 0 && 
            app.formatLetterData.resumeSummary.indexOf('経歴書') < 0) {
            console.error('no problem')
          } else {
            app.$message({
              message: '送付状の同封書類に職務経歴書の記載があります。ご確認ください。',
              type: 'error'
            })
            app.$eventHub.$emit('payment_result', 'error')
            return
          }
        }
      }
      if (this.letterInnerHtml == '') {
        this.setLetterInnerHtml()
      }
      if (!this.$globalVar.qmailRirekishoHtml) {
        this.$message({
          message: '問題が発生しました。画面を更新してから再度購入ボタンを押してください。',
          type: 'error'
        })
        return
      }
      const formData = new FormData()
      formData.append('stripe_token', this.token)
      formData.append('quickmail_post', this.formatData.addressData_postNumber)
      formData.append('quickmail_address1', this.formatData.addressData_address1)
      formData.append('quickmail_address2', this.getInputValue(this.formatData.addressData_address2))
      formData.append('quickmail_companyname', this.formatData.addressData_companyName)
      formData.append('quickmail_staffname', this.addressDataStaffName)
      formData.append('rirekisho_html', this.$globalVar.qmailRirekishoHtml)
      formData.append('keirekisho_html', this.keirekishoInnerHtml)
      formData.append('letter_html', this.letterInnerHtml)
      formData.append('letter_flag', this.formatData.addressData_isLetter)
      formData.append('keirekisho_flag', this.formatData.addressData_isKeirekisho ? '1':'0')
      formData.append('format_id', this.formatData.selFormat)
      formData.append('font_name', this.formatData.selFontStyle4DB)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('from_post', this.formatData.from_post)
      formData.append('from_address1', this.formatData.from_address1)
      formData.append('from_address2', this.getInputValue(this.formatData.from_address2))
      formData.append('from_name', this.formatData.from_name)
      formData.append('app_flag', this.$site.appFlag)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '3')
      formData.append('site_flag', 'r')
      formData.append('payment_code', this.formatData.ecCode)
      formData.append('payment_method', this.paymentMethodTab)

      const _tempHtml = this.$refs.previewLetterFormat.$el.innerHTML 
      + this.$refs.previewRirekishoFormat.$el.innerHTML 
      + this.$refs.previewKeirekishoFormat.$el.innerHTML
      formData.append('all_html', _tempHtml)

      formData.append('payment_cost', 1100)
      formData.append('contents_flag', 'q')
      formData.append('merchant_payment_id', merchant_payment_id)
      this.$axios
        .post(this.$varuna.endPoints.savePaypayTempdata, formData, {timeout: 60000})
        .then(function (response) {
          if (response.data['status'] == 'success') {
            app.$message({
              message: 'PayPayページに遷移します',
              type: 'success'
            })
            // location.href=url
            app.paypay_url = url
            app.merchant_payment_id = merchant_payment_id
            app.$modal.show('open_paypay_modal')
      return
          } else {
            app.$message({
              message: '決済失敗しました',
              type: 'error'
            })
          }
        })
        .catch(function (error) {
          app.$message({
            message: '決済失敗しました',
            type: 'error'
          })
          app.$eventHub.$emit('payment_email_result', 'error')
        }).finally(function () {
        })
    },
    changePaymentMethod() {
      console.error(this.paymentMethodTab)
      this.$eventHub.$emit('change_payment_method', this.paymentMethodTab)
    },
    selectedPostnumber() {
      if (String(this.formatData.addressData_postNumber).length === 7) {
        this.setAddressFromZip(this.formatData.addressData_postNumber)
      }
    },
    getInputValue: function (inputvalue) {
      return inputvalue?inputvalue:''
    },
    setAddressFromZip: function (postNumber) {
      const app = this
      const callback = function (data) {
        app.$refs.address1.value = data.kanji
        app.formatData.addressData_address1 = data.kanji
      }
      this.$formLib.addressFromZip(postNumber, callback)
    },
    testFunction: function (str) {
      console.error("testFunction:" + str)
      this.$eventHub.$emit('payment_result', '8989')
    },
    previewScrollTo: function (id) {
      if (!id) {
        return
      }
      this.$nextTick(function () {
        const element = document.getElementById(id)
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'center'
          })
        }
      })
    },
    setPreviewScale: function () {
      let viewerRef = this.$refs.mainViewer
      this.$nextTick(function () {
        const clientWidth = this.$refs.mainViewer.clientWidth
        this.previewScale = clientWidth / Math.max(clientWidth, DOC_PAPER_WIDTH_PX)
        this.$nextTick(function () {
          this.setPreviewHeight()
        })
      })
    },
    setPreviewHeight: function () {
      const rirekishoheight = this.$refs.previewRirekishoFormat.$refs.previewMain.getBoundingClientRect().height
      const keirekishoheight = this.$refs.previewKeirekishoFormat.$refs.previewMain.getBoundingClientRect().height
      const letterheight = this.$refs.previewLetterFormat.$refs.previewMain.getBoundingClientRect().height
      const labelheight = this.$refs.previewLabelFormat.$refs.previewMain.getBoundingClientRect().height
      this.previewRirekishoViewerCss = {
        height: rirekishoheight + 30 + 'px'
      }
      this.previewKeirekishoViewerCss = {
        height: keirekishoheight + 30 + 'px'
      }
      this.previewLetterViewerCss = {
        height: letterheight + 'px'
      }
      this.previewLabelViewerCss = {
        height: labelheight + 'px'
      }
    },
    setLetterInnerHtml: function () {
      this.letterInnerHtml = this.$refs.previewLetterFormat.$el.innerHTML
    },
    setRirekishoInnerHtml: function () {
      if (this.currentCardId == 'rirekisho') {
        this.$globalVar.qmailRirekishoHtml = this.$refs.previewRirekishoFormat.$el.innerHTML
      }
      console.error(this.$globalVar.qmailRirekishoHtml)
      this.rirekishoInnerHtml = this.$refs.previewRirekishoFormat.$el.innerHTML
    },
    setKeirekishoInnerHtml: function () {
      this.keirekishoInnerHtml = this.$refs.previewKeirekishoFormat.$el.innerHTML
    },
    setCheckLetter: function () {
      if (this.formatLetterData.createDate) {
        this.formatData.addressData_isLetter = '1'
      } else {
        this.formatData.addressData_isLetter = '0'
      }
    },
    setAddressDataStaffName: function () {
      if (!this.formatData.addressData_staffName) {
        this.isNoneStaffname = true
        this.addressDataStaffName = 'ご担当者'
      } else {
        this.addressDataStaffName = this.formatData.addressData_staffName
      }
    },
    showPreview: function () {
      this.previewDialogVisible = true
      this.previewTabActive = 'previewFormat'
      this.setPreviewScale()
      this.$nextTick(function () {
        this.previewScrollTo(this.currentCardPreviewJumpId)
      })
    },
    selectFormat: function (isMessaege) {
      // console.error(this.$refs.previewRirekishoFormat.$el)
      // console.error(this.$refs.previewRirekishoFormat.$el.innerHTML)
      for (let key in this.$site.rirekishoFormatsIndex) {
        let item = this.$site.rirekishoFormatsIndex[key]
        if (item.id == this.formatData.selFormat) {
          this.rirekisho_preview = item.components.preview
          this.formatId = item.id
          this.formatData.rirekishoFormatName = item.title
          if (!isMessaege) {
            this.$message({
              message: this.formatData.rirekishoFormatName+'に履歴書フォーマットを変更しました。プレビューをご確認ください',
              type: 'success'
            })
          }
          this.rirekishoUrl = '/format/'+this.formatId+'/edit/profile'
          this.rirekishoOutputUrl = '/format/'+this.formatId+'/edit/output'
        }
      }
      this.$nextTick(function () {
        this.$refs.previewRirekishoFormat.checkValid()
        this.$nextTick(function () {
          this.setRirekishoInnerHtml()
        })
      })
    },
    selectFont: function() {
      const app = this
      this.formatData.selFontStyle = this.formatData.selFont
      this.formatData.selFontStyle4DB = this.formatData.selFont
      
      for (const label_name in this.fontOptions) {
        if (this.fontNames[label_name].value == this.formatData.selFont) {
          this.formatData.selectedFontName = '選択したフォント（' + this.fontNames[label_name].label + '）'
          this.formatData.selFontStyle4DB = this.fontNames[label_name].label
        }
      }
    },
    cleanUp: function (name, value) {
      if (name === 'postNumber') {
        value = value.replace('-', '')
        value = this.$formLib.zenToHanNumber(value)
        return String(value)
      }
    },
  },
  watch: {
    'formatData.addressData_postNumberX': function (newValue, oldValue) {
      console.error('formatData.addressData_postNumber')
      // skip first load
      if (!oldValue) {
        return
      }
      const postNumber = this.cleanUp('postNumber', String(newValue))
      if (String(postNumber).length === 7) {
        this.setAddressFromZip(postNumber)
      }
    },
    'formatData.addressData_staffName': function (newValue, oldValue) {
      if (newValue.indexOf('さま') >= 0 || newValue.indexOf('様') >= 0) {
          this.isValidStaffname = true
      } else {
          this.isValidStaffname = false
      }
    }
  },
  mounted: function () {
  },
  beforeMount: function () {
    const app = this
    this.$iterateStorage(function (value, key, iterationNumber) {
      if (key === 'basicData') {
        app.basicData = value
        app.formatData.from_name = app.basicData.lastName + ' ' +  app.basicData.firstName
        app.formatData.from_post = app.basicData.postNumber
        app.formatData.from_address1 = app.basicData.address1
        app.formatData.from_address2 = app.basicData.address2
      }
      if (key === 'format_rirekisho') {
        app.formatRirekishoData = value
        if (value.selFormat) {
          app.selectFormat(true)
        }
      }
      if (key === 'format_shokumukeirekisho') {
        app.formatKeirekishoData = value
      }
      if (key === 'format_letter') {
        app.formatLetterData = value
        app.formatData.addressData_companyName = value.company_name
        app.formatData.addressData_staffName = value.staff_name
      }
      if (key === 'recentEdit') {
        if (value.FormatId == 'letter' || value.FormatId == 'shokumukeirekisho') {
          app.selectFormat(true)
        } else {
          app.formatData.selFormat = value.FormatId
          app.selectFormat(true)
        }
      }
    }, function (err) {})
    let idx = 0
    for (let key in this.$site.rirekishoFormatsIndex) {
      let item = this.$site.rirekishoFormatsIndex[key]
      if (item.id != 'letter' && item.id != 'shokumukeirekisho') {
        this.formatListOptions[idx] = {
          value: item.id,
          label: item.title
        }
        idx++
      }
    }
    this.showPreview()
    this.$eventHub.$on('token_created', this.tokenCreated)
    this.$eventHub.$on('save_paypay_tempdata', this.savePayPayTempData)
  },
  destroyed: function () {
    this.$eventHub.$off('token_created', this.tokenCreated)
    this.$eventHub.$off('save_paypay_tempdata', this.savePayPayTempData)
  }
}
</script>
